import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
import TemplatePage from "./TemplatePage";
import PageSection from "../components/page/Section";

function PageNotFound() {
  const header = {
    style: {
      fontFamily: "abnes",
      fontSize: "48px",
      color: "white",
      lineHeight: "1em",
    },
  };

  const headerSubtitles = {
    style: {
      fontFamily: "poppins",
      fontWeight: "400",
      fontSize: "20px",
      color: "white",
      lineHeight: "1em",
    },
  };

  return (
    <TemplatePage>
      <PageSection>
        <Stack spacing={4} sx={{ height: "100vh" }}>
          <Typography {...header}>Oops!</Typography>
          <Typography {...headerSubtitles}>
            Sorry! We could not find the page you were looking for.
          </Typography>
        </Stack>
      </PageSection>
    </TemplatePage>
  );
}

export default PageNotFound;
